// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2qiVk","content":"styles_content__Zrw0a","checkbox":"styles_checkbox__1E0Za","checkboxLabel":"styles_checkboxLabel__1kAFo"};